import { axiosClient } from '@/libs/axios-client';

export const getSummary = async (days = 30) => {
  const response = await axiosClient.get('/ai-usage/summary', {
    params: { days },
  });
  return response.data;
};

export const updateSettings = async (payload) => {
  const response = await axiosClient.put('/ai-usage/settings', payload);
  return response.data;
};

export const importGoogleBilling = async () => {
  const response = await axiosClient.post('/ai-usage/google-billing/import');
  return response.data;
};
